import classes from "./styles.module.css"
import {Button} from "@mui/material";
import {useState} from "react";
import YesNo_modal from "../Modal/YesNo_modal";

const Row_org =(props)=>{

    const [data, setData] = useState(props.data);
console.log(props);
const loadDisplay = () => {
    props.loadDisplay(props.data.id);
};
const loadServis = () => {
    if (props.loadServis) props.loadServis(props.data.id);
};

    const handleEdit = () => {
    if (props.onEdit) {
        props.onEdit(data);
    }
}

    const act = (
        <>
            <Button onClick={handleEdit} color="primary" variant="outlined" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' }, minWidth: { xs: 'auto', sm: '100px' }, width: { xs: '100%', sm: 'auto' } }}>Upravit</Button>
            <Button onClick={loadDisplay} color="primary" variant="outlined" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' }, minWidth: { xs: 'auto', sm: '120px' }, width: { xs: '100%', sm: 'auto' } }}>Zobrazovače</Button>
            <Button onClick={loadServis} color="primary" variant="outlined" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' }, minWidth: { xs: 'auto', sm: '90px' }, width: { xs: '100%', sm: 'auto' } }}>Servis</Button>
            <Button onClick={()=>props.onDelete(data)} color="primary" variant="outlined" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' }, minWidth: { xs: 'auto', sm: '100px' }, width: { xs: '100%', sm: 'auto' } }}>Odstranit</Button>
        </>
    );

    if (props.renderAsGridRow) {
        return (
            <div style={{ display: 'contents' }}>
                <div className={`${classes.cellData} ${classes.cellColFirst} ${props.isLastRow ? classes.cellRowLast : ''} ${classes.column}`}><span className={classes.mobileLabel}>Organizace:</span>{data.name}</div>
                <div className={`${classes.cellData} ${classes.cellColLast} ${props.isLastRow ? classes.cellRowLast : ''} ${classes.columnAct}`}>{act}</div>
            </div>
        );
    }

    return <> <div className={classes.columnsOrg}>
        <div className={classes.column}>
            <span className={classes.mobileLabel}>Organizace:</span>
            {data.name}
        </div>
        <div className={classes.columnAct}>
            {act}
        </div>
    </div>
    </>
}
export default Row_org;